@file:OptIn(InternalResourceApi::class)

package havn.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/havn.composeapp.generated.resources/"

@delegate:ResourceContentHash(240_959_146)
internal val Res.drawable.havn_auth_logo: DrawableResource by lazy {
      DrawableResource("drawable:havn_auth_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/havn_auth_logo.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("havn_auth_logo", Res.drawable.havn_auth_logo)
}
